import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import BarChartView  from 'report/BarChartView.js';
import listService from 'ListService';


class ControlBarChartFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        attributes.verticalAxis='linearAxis';
        attributes.horizontalAxis='categoryAxis';
        attributes.silent = false;
        attributes.mainLength = '7';
        attributes.styleBGColorText = '#FFFFFF';
        attributes.lineColor = '';
        attributes.barColor = '#E48701';
        attributes.axisColor = '#BBCCDD';
        attributes.fontFamily = listService.accountSettings.DefaultFontSelected || "verdana";
        attributes.fontSize = '10';
        attributes.textWeight = '';
        attributes.textStyle  = '';
        attributes.Columns = { Column: [{ id:'0', Properties: {
            usesExpression: "false",
            formatoption: "",
            fieldId: "",
            width: "150",
            format: "none",
            caption: "",
            sortType: "none",
            visible: "true",
            setDynamicFilter: "false",
            align: "left",
            aggregation: "group",
            fieldDataType: "",
            sortOrder: "0"
        }},
            { id: '1', Properties: {
                usesExpression:"false",
                formatoption:"",
                fieldId:"",
                width:"150",
                format:"none",
                caption:"",
                sortType:"none",
                visible:"true",
                setDynamicFilter:"false",
                align:"left",
                aggregation:"count",
                fieldDataType:"",
                sortOrder:"0"
            }}
        ]};
        attributes.resizePadding = 2;
		attributes.minWidth = 100;
		attributes.minHeight = 150;
        attributes.lowestHeight = 150;
        attributes.barChartType = 'clustered';
        attributes.fontFamily = listService.accountSettings.DefaultFontSelected || "verdana";
		attributes.fontSize = '10';
		attributes.textWeight = '';
		attributes.textStyle  = '';
        
        attributes.additiveDynamicFilter = 'true'; 
        attributes.respectDynamicFilter = 'true'; 
        attributes.setDynamicFilter = 'true';

        const view = new BarChartView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlBarChartFactory = new ControlBarChartFactory();

export default controlBarChartFactory;